<template>
  <div v-if="!consult_id" class="medical-history"><p>상담건이 없습니다.</p></div>
  <div v-else class="medical-history" :data-consult-id="consult_id">
    <form id="app" method="post">
    
    <!-- 진료 특이사항 -->
    <ConsultMemoForm :consult_id="consult_id" :consult_type="consult_type"></ConsultMemoForm>
    
    <!-- 내용 -->
    <div v-if="note_status!=0 && note_status!=9" class="history-cont">
        <h3>개인정보제공 동의</h3>
        <div class="guest-info" v-if="is_certi">
          <dl>
            <dt>본인(자녀)이름</dt>
            <dd v-if="consult.consult_user_type==1">
              {{consult.consult_user_name ? consult.consult_user_name : '-'}}<button type="button" class="btn-agreement" @click="viewAgreement()">동의서 조회/다운</button>
            </dd>
            <dd v-else>
              {{ consult.name }} ( {{consult.consult_user_name}} )<button type="button" class="btn-agreement" @click="viewAgreement()">동의서 조회/다운</button>
            </dd>
            <dt>동의일시</dt>
            <dd>{{ consult.created_at }}</dd>
          </dl>
        </div>        
    </div>
    <div v-if="is_admin" class="wrap">
        <h3>병원 알림 보내기(to 병원)</h3>
        <div id="send_msg" class="push-cont">
          <div class="note-cont">
          <select name="hosp-msg-id" id="hosp-msg-id" v-model="sendMessage" placeholder="메시지를 선택하세요.">
              <option v-for="row in msgHospCodes" :value="row.idx" :key="row.idx">{{ row.subject }}</option>
          </select>
          <button class="user-info-btn" @click="sendHospMsg()" :disabled="!is_click">전송</button>
          </div>
        </div>
    </div>
    <div class="history-cont">
        <h3>환자 알림 보내기(to 사용자)</h3>
        <div id="send_msg" class="push-cont" v-if="is_msg">
          <div class="note-cont">
            <textarea autocomplete="off" v-model="send_msg" @keyup.enter.prevent />
            <span><button type="button" class="btn-submit" @click="send_push" :disabled="!is_click">전송</button></span>
          </div>   
        </div>        
    </div>
    <div v-if="!is_admin" class="history-cont">
        <h3>관리자 알림 보내기(to 관리자)</h3>
        <div id="send_msg" class="push-cont" v-if="is_msg_admin">
          <div class="note-cont">
            <textarea autocomplete="off" v-model="send_msg_admin" @keyup.enter.prevent />
            <span><button type="button" class="btn-submit" @click="send_push_admin" :disabled="!is_click">전송</button></span>
          </div>   
        </div>        
    </div>    
    <div class="history-client">
        <h3>알림 내역</h3>
        <div class="push-msg" v-for="(reply, index) in push_list" :key="index">
          <div class="note-cont">
            <span class="date">{{reply.created_at | date_format('YYYY-MM-DD (dd) HH:mm')}}</span>
            <div v-if="is_admin&&reply.display_position=='L'" class="history-txt">({{reply.dr_name}})</div>
            <div v-if="is_admin&&reply.display_position=='R'" class="history-txt"><div style="margin-left:20px;">({{reply.uname}})</div></div>
          </div>
          <div v-if="reply.display_position=='L'" class="history-txt"><span v-html="reply.content.replace(/\n/gi,'<br>')"></span></div>
          <div v-if="reply.display_position=='R'" class="history-txt">
            <div style="margin-left:20px;color:blue"><span v-html="reply.content.replace(/\n/gi,'<br>')"></span></div>
          </div>
        </div>
        <div v-if="push_list.length==0" class="no-msg">
          <span>보낸 알림 정보가 없습니다.</span>
        </div>
    </div>
    </form>
    <div id="myModal" class="modal" v-if="is_modal">
        <!-- Modal content -->
        <div class="modal-content">
            <div class="modal-header">
            </div>
            <div class="modal-body">
                <Agreement :consult_id="consult_id" :consult="consult" :note_status="note_status" @closeEvent="closeEvent"></Agreement>
            </div>
            <div class="modal-footer">

            </div>
        </div>
    </div>
  </div>
  
</template>

<script>
  //import { mapState, mapActions } from 'vuex'
  import { mapState } from 'vuex'
  import { nameByConstMixin } from '@/lib/mixins'
  import URLS from '@/lib/urls'  
  import Upload from '@/lib/upload'
  import {CONSULT_STATUS, CONSULT_TYPE, MOMENT, STATUS_CODE, UPLOAD_TYPE } from '@/lib/constants'
  import ConsultMemoForm from '@/components/ConsultMemo/ConsultMemoForm.vue'
  import Agreement from '@/components/Common/Agreement.vue'

  export default {
    mixins: [nameByConstMixin],
    name: 'consult-notice',
    props: ['consult_id', 'consult_type', 'is_admin', 'is_certification', 'note_status'],
    data () {
      return {
        consult: {},
        push_list: [],
        note: {},
        replies: [],
        send_msg: '',
        send_msg_admin: '',
        is_msg: true,
        is_msg_admin: true,
        my_reply : {},
        image_yn : false,
        // is_submit: false,
        consult_name: '',
        is_certi: true,
        msgHospCodes: [],
        sendMessage: '',
        is_sendMessage: true,
        is_click: true, //버튼 클릭여부
        is_modal: false,    //동의서

      }
    },
    computed: {
      ...mapState(['account'])
    },
    methods: {
      viewAgreement(){
        this.is_modal = true;
      },
      async closeEvent() {
          this.is_modal = false;
      },      
      async sendHospMsg() {
        if(!this.sendMessage) {
            alert('내용을 선택해 주세요.');
            return;
        }

        this.is_click = false;

        let post_data = {
          push_send_type: this.sendMessage
          // push_dr_id: this.account.dr_id,
        }
        
        let { data } = await this.axios.post(`consult_note/${this.consult_id}/admin_push`, post_data)

        if (data.status === STATUS_CODE.OK) {
          alert('메세지를 보냈습니다.')
          this.sendMessage = ''
          this.is_click = true;
          // this.push_log_insert();
        } else {
          alert('메세지 송신 에러: ' + data.msg);
          this.is_click = true;
        }

      },
      async hosp_msg_list () {  //전문 진료 분야 가져오기 20190411 kjw
          // this.$log.debug('hosp_msg_list',this.is_sendMessage)
          let routerName = 'appdata/code/17';
  
          let {data: {resp}} = await this.axios.get(routerName)
          this.msgHospCodes = resp;
          this.sendMessage = this.msgHospCodes[0].subject;
      },
      img_click(url) { 
        url = url.replace(/_sm/gi, '')
        //let img_detail = window.open(url,"img_detail","width=800,height=600")
        let routeData = this.$router.resolve(`/image_view/111`);
        this.popupCenter(routeData.href, "image_view", 800, 800, 0, 200);
      },
      async send_push() {
        if(!this.send_msg) {
          alert("알림 메시지가 비어 있습니다.")
          return
        }

        this.is_click = false;
        
        let post_data = {
          push_title: `${this.consult_name} 알림 \n(${this.consult.dr_name})`, 
          push_msg: this.send_msg,
          push_dr_id:this.consult.dr_id, 
          push_uid:this.consult.uid,
          push_consult_type: 9,
          push_send_type:  this.is_admin ? 3 : 1
        }

        if(this.is_admin) {
          post_data.push_title = `${this.consult_name} 알림 \n(엠디톡)`;
          post_data.push_dr_id = this.account.pharm_id;
          post_data.push_msg = '[엠디톡]' + this.send_msg;
        }

        // if(this.is_admin) post_data.push_msg = '(엠디톡 관리자)' + post_data.push_msg;
        // else post_data.push_msg = `(${this.consult.dr_name} 선생님)` + post_data.push_msg;
        // console.log('post_data', post_data.push_title)

        let { data } = await this.axios.post(`consult_note/${this.consult_id}/push`, post_data)

        if (data.status === STATUS_CODE.OK) {
          alert('메세지를 보냈습니다.')
          this.send_msg = ''
          this.is_click = true;
          this.push_log_insert();
        } else {
          alert('메세지 송신 에러: ' + data.msg);
          this.is_click = true;
        }
      },
      async send_push_admin() {
        if(!this.send_msg_admin) {
          alert("알림 메시지가 비어 있습니다.")
          return
        }

        this.is_click = false;
        
        let post_data = {
          push_title: `${this.consult_name} 알림 \n(${this.consult.dr_name})`, 
          push_msg: this.send_msg_admin,
          push_dr_id:this.consult.dr_id, 
          push_uid:this.consult.uid,
          push_consult_type: 9,
          push_send_type: 2
        }

        let { data } = await this.axios.post(`consult_note/${this.consult_id}/push`, post_data)

        if (data.status === STATUS_CODE.OK) {
          let purio_param = {
            push_send_type: 0
          }
          // 알림톡은 에러 시 별도 처리하지 않는다.
          await this.axios.post(`consult_note/${this.consult_id}/admin_push`, purio_param);
          
          alert('메세지를 보냈습니다.')
          this.send_msg_admin = ''
          this.is_click = true;
          this.push_log_insert();
        } else {
          alert('메세지 송신 에러: ' + data.msg);
          this.is_click = true;
        }
      },
      async push_log_insert() {
        this.push_list = [];

        let { data } = await this.axios.get(`push?note_yn=Y&dr_id=${this.consult.dr_id}&consult_id=${this.consult.note_id}&uid=${this.consult.uid}`);

        if(data.status == "200")  {
          this.push_list = data.resp;
          
          for(var i = 0; i < this.push_list.length; i++){
            //console.log('attach_url'+i, this.push_list[i].attach_url);
            // this.push_list.subject.replace('#{환자이름}', this.consult.name);
            // this.push_list.subject.replace('#{시간}', this.consult.created_at);
            if(this.push_list[i].attach_url)
              this.push_list[i].img_url = URLS.STATIC + UPLOAD_TYPE.DR_COMMENT + "/" + this.push_list[i].dr_id + "/" + this.push_list[i].consult_id + "/" + this.push_list[i].attach_url;
          }
        }
      },
      async load_comment(consult_id) {
        this.send_msg = ''

        let { data } = await this.axios.get(`consult_note/user/${consult_id}`)
        let { resp } = data

        this.consult = Object.assign({}, this.consult, resp)
        this.push_log_insert();
      }
    },
    async mounted () {
      // console.log('consultnotice 마운트됨!')
      await this.hosp_msg_list();
      
      if(this.consult_id) {
        // console.log('consultnotice mounted', this.consult_id);
        this.load_comment(this.consult_id);
      }
    },
    watch: {
      consult_id: async function (val) {
        // console.log('ConsultNotice consult_id 변경됨(watch)', val)
        if(this.consult_type == 9) this.consult_name = '전화상담';
        else if(this.consult_type == 1) this.consult_name = '영상상담';
        else if(this.consult_type == 2) this.consult_name = '쪽지상담';
        else this.consult_name = '엠디톡(MDtalk) 상담';    
        this.load_comment(val);
      },
      note_status: function (note_status) {
        //  console.log('ConsultNotice note_status 변경됨(watch)', note_status)
         if(this.note.status<note_status) this.note.status = note_status;
        //  this.load_consult_status();
       },
    },
    components: {
      Agreement, ConsultMemoForm
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .push-cont .push-box{
        height:32px;
        line-height:32px;
        margin-bottom:7px;
        border:1px solid #999;
    }
    .push-cont .push-box input{
        float:left;
        width:74%;
        height:32px;
        line-height:32px;
        padding:0 3%;  
        border:0;
    }
    .push-cont .push-box .consult-enter{
        display:block;
        padding:0;
        margin:0;
        width:20%;
        height:32px;
        line-height:31px;
        border:0;
        background:#999;
        color:#fff;
    }
    
    .medical-history > div {
        margin-bottom: 20px;
    }

    .medical-history h3 {
        color: #4c4c4c;
        margin-bottom: 10px;
        letter-spacing: -.5px;
        font: 500 16px 'Noto Sans KR', sans-serif;
    }

    /* .medical-history h3:nth-child(2) {
        margin-top: 10px;
    } */

    .history-txt {
        width: 100%;
        margin: 0;
        padding: 5px 10px 10px 10px;
        box-sizing: border-box;
        background-color: #f5f6fa;
        font: 400 12px 'Noto Sans KR', sans-serif;
        min-height: 35px;
        word-wrap: break-word;
        word-break:keep-all;
    }

    .history-txt-R {
        width: 100%;
        margin: 0;
        padding: 5px 10px 10px 10px;
        box-sizing: border-box;
        background-color:#E6F2FF;
        font: 400 12px 'Noto Sans KR', sans-serif;
        min-height: 35px;
        word-wrap: break-word;
        word-break:keep-all;
    }

    .history-txt .cur-img{
      margin-right: 20px;
      text-align:left;
    }
    .history-txt .tot-img{
      width: 200px;
      text-align:left;
      display: inline-block;
      /* margin-left: 110px; */
      text-align:right;
    }
    .history-txt .change-img{
      cursor: pointer;
      text-align:left;
    }
    .history-txt .change-img-o{
      color: #f5f6fa;
      text-align:left;
    }
    

    .history-img {
        width: 300px;
        margin-top: 10px;
        background-color: #f5f6fa;
        min-height: 300px;
        transform: translateX(0px);
    }

    .history-client-list ul,
    .history-before-list ul{float: left;}

    .history-client-list li,
    .history-before-list li{
        margin-bottom: 10px;
        height: 20px;
        font: 400 12px 'Noto Sans KR', sans-serif;
    }

    .history-client-list .client-lt,
    .history-before-list .before-lt{
        width: 120px;
        color: #b7b7b7;
    }

    .history-client-list .client-rt,
    .history-before-list .before-rt{
        width: 200px;
        color: #484848;
    }

    .consult-enter {
      float:right;
      padding: 5px;
    }
        /*2019-08-12 ssh*/
    .push-cont h4{
      margin-bottom:10px;
      font-size:16px;
      font-weight:bold;
      color:#4c4c4c;
    }

    .push-cont .note-cont{
      margin:10px 0;
      padding:10px;
      background:#f5f6fa;
      text-align:right;
      word-break:keep-all;
    }

    .push-cont .note-cont textarea{
      display:block;
      width:100%; 
      height:60px;
      padding:10px;
      font:400 12px Noto Sans KR,sans-serif;
      text-align:left;
      word-break:keep-all;
      box-sizing:border-box;
      -webkit-box-sizing:border-box;
    }
    .push-cont .note-cont .history-txt{
      text-align:left;
      padding:0px 10px;
      min-height:0;
      word-break:keep-all;
    }

    /* 2019-11-13 병력정보 UI 변경  */
    .guest-info{
        margin-bottom:10px;
    }
    .guest-info dt,
    .guest-info dd{
      font:400 12px Noto Sans KR,sans-serif;
      min-height:20px;
      margin-bottom:5px;
    }
    .guest-info dd:last-child{
      margin-bottom:10px;
    }
   
    .guest-info dt{
      float:left;
      width:110px;
      margin-right:10px;
      color:#b7b7b7;
    }
    .guest-info dd{
      overflow:hidden;
      color:#484848;
    }
    .guest-info .data-info{
      display:inline-block;
      width:100%;
      vertical-align:top;
    }

    .push-msg{
      margin:0 0 5px 0;
    }
    .push-msg .note-cont{
      padding:5px 15px 5px 10px;
      background:#f5f6fa;
      text-align:right;
      font:400 12px Noto Sans KR,sans-serif;
    }
    .push-msg .note-cont textarea{
      display:block;
      width:100%; 
      height:150px;
      padding:10px;
      font:400 12px Noto Sans KR,sans-serif;
      text-align:left;
      word-break:keep-all;
      box-sizing:border-box;
      -webkit-box-sizing:border-box;
    }
    .push-cont .note-cont .btn-submit{
      width:60px;
      height:25px;
      /* line-height:32px; */
      padding: 0;
      margin-top:5px;
      border:0;
      background:#5e71e9;
      color:#fff;
      font-weight:bold;
      cursor:pointer;
    }
    .push-msg .note-cont .history-txt{
      text-align:left;
      padding:0px 10px;
      min-height:0;
      word-break:keep-all;
    }
    .push-msg .note-cont .date{
      margin:0px 0px 20px 0px;
      float:right;
      font:400 12px Noto Sans KR,sans-serif;
    }

    .img-area{
      margin-top:-10px;
      padding:0px 10px;
      background:#f5f6fa;
      cursor: pointer;
    }
    .add-interior-thumb {font-size: 0;}
    .add-interior-thumb span {
        float: left;
        width: 120px;
        height: 90px;
        margin: 0 10px 10px 0;
    }

    .add-interior-thumb-upload {
        display: inline-block;
        width: 120px;
        height: 90px;
        border: none;
        position: relative;
        border: 1px solid #999;
        background-color: transparent;
    }

    .add-interior-thumb-upload span {
        display: block;
        width: 35px;
        height: 35px;
        color: #999;
        position: absolute;
        text-align: center;
        left: 50%;
        top: 50%;
        border-radius: 50%;
        border: 1px solid #999;
        transform: translate(-50%, -50%);
        font: 400 24px/35px 'Noto Sans KR', sans-serif;
    }

    .no-msg {
      margin-left: 10px;
      font: 400 12px 'Noto Sans KR', sans-serif;
    }

    /** 
     * 이미지 업로드
     */
    .thumbnail {
        /*padding:4px;*/
        border: 1px solid #ddd;
        display: inline-block;
        float:left;
        overflow: hidden;
        position:relative;
        line-height: 0;
      }

    .thumbnail img {
        width: 100%;
        height: 100%;
    }
    .thumbnail .icon-remove {
        position: absolute;
        left: 0;
        top: 0;
    }

    .btn-agreement {
      /* float: left; */
      width:110px;
      height:20px;
      line-height:32px;
      padding-bottom:5px;
      margin-left:10px;
      border:0;
      background:#5e71e9;
      font: 400 12px 'Noto Sans KR', sans-serif;
      color:#fff;
      /* font-weight:bold; */
      cursor:pointer;
    }

    .etc-btn {
      width:110px;
      padding: 5px;
      margin-left:10px;
      line-height:32px;
      padding: 2px;
      margin-left:10px;
      cursor:pointer;
      position: relative;
      border: 1px solid #aaa;
      background:#ccc;
      font: 400 12px 'Noto Sans KR', sans-serif;   
    }

    #hosp-msg-id {
        /* width: 350px; */
        float: left;
        width: 83%;
        padding: 3px 5px;
        font: 400 12px 'Noto Sans KR', sans-serif;
        background: url(../../assets/home/select.png) 98% no-repeat;
    }

    #hosp-msg-content{
        width: 405px; 
        padding: 3px 10px;
        margin: 5px 0;
        font: 400 12px 'Noto Sans KR', sans-serif;
    }

    .user-info-btn {
        /* float:left; */
        /* display:block; */
        width: 50px;
        padding: 3px;
        cursor: pointer;
        position: relative;
        box-sizing: border-box;
        /* margin: 10px auto 10px; */
        margin-left: 5px;
        /* margin-bottom: 10px; */
        font: 400 12px 'Noto Sans KR', sans-serif;   
    }

    /* The Modal (background) */
    .modal {
        display: block; /* Hidden by default */
        position: fixed; /* Stay in place */
        opacity:0.99;
        z-index: 100; /* Sit on top */
        padding: 0; /* Location of the box */
        left: 0;
        top: 0;
        width: 100%; /* Full width */
        height: 100%; /* Full height */
        overflow: auto; /* Enable scroll if needed */
        background-color: rgb(9,9,9); /* Fallback color */
        background-color: rgba(0,0,0,0.4); /* Black w/ opacity */
    }

    /* Modal Content */
    .modal-content {
        position: relative;
        background-color: #fefefe;
        margin: auto;
        margin-top: 100px;
        padding: 0;
        border: 1px solid #888;
        width: 700px;
        box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2),0 6px 20px 0 rgba(0,0,0,0.19);
        -webkit-animation-name: animatetop;
        -webkit-animation-duration: 0.4s;
        animation-name: animatetop;
        animation-duration: 0.4s
    }

    /* Add Animation */
    @-webkit-keyframes animatetop {
        from {top:-300px; opacity:0} 
        to {top:0; opacity:1}
    }

    @keyframes animatetop {
        from {top:-300px; opacity:0}
        to {top:0; opacity:1}
    }

    /* The Close Button */
    .close {
        color: white;
        float: right;
        font-size: 20px;
        font-weight: bold;
    }

    .close:hover,
    .close:focus {
        color: #000;
        text-decoration: none;
        cursor: pointer;
    }

    .modal-header {
        padding: 5px 20px;
        background-color: #111;
        color: white;
    }

    .modal-body {padding: 0px 0px;}

    .modal-footer {
        padding: 2px 10px;
        background-color: #111;
        color: white;
    }

</style>
